/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VirtualHealthLibraryStrictHttpResponse } from '../../virtual-health-library-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaCategoryModel } from '../../models/media-category-model';

export interface MediaCategoryListGet$Params {
}

export function mediaCategoryListGet(http: HttpClient, rootUrl: string, params?: MediaCategoryListGet$Params, context?: HttpContext): Observable<VirtualHealthLibraryStrictHttpResponse<Array<MediaCategoryModel>>> {
  const rb = new RequestBuilder(rootUrl, mediaCategoryListGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VirtualHealthLibraryStrictHttpResponse<Array<MediaCategoryModel>>;
    })
  );
}

mediaCategoryListGet.PATH = '/Media/CategoryList';
